'use strict';

var $ = require('jquery');

var players = {};

function stopVideo(id) {
	var player = players[id];

	if (player) {
		player.stopVideo();
	}
}

function onPlayerStateChange(event, id) {
	if (event.data === window.YT.PlayerState.PLAYING) {
		$('#' + id).trigger('youtube-video-playing');
	}
}

function init($context) {
	$('iframe[src*="youtube"]', $context).each(function() {
		var id = $(this).attr('id');
		var jsApiEnabled = $(this).attr('src').indexOf('enablejsapi=1') > 0;

		if (jsApiEnabled) {
			players[id] = new window.YT.Player(id, {
				events: {
					'onStateChange': function (event) {
						onPlayerStateChange(event, id);
					}
				}
			});
		}
	});
}

module.exports = {
	init: function ($context) {
		window.onYouTubeIframeAPIReady = init($context);
	},

	stopVideo: function (id) {
		stopVideo(id);
	}
};